export default __webpack_public_path__ + "static/Europe--2x-e27355956cc9b85685d1b89844c91270.png";